import * as React from "react";
function SvgLightbulb(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="lightbulb_svg__Layer_1"
      data-name="Layer 1"
      viewBox="0 0 168 168"
      ref={svgRef}
      {...props}
    >
      <defs>
        <pattern
          id="lightbulb_svg__New_Pattern_6"
          width={6}
          height={6}
          patternTransform="matrix(1.09 0 0 1.09 -27.69 242.21)"
        >
          <path fill="none" d="M0 0h6v6H0z" />
          <path
            d="M1.5 3A1.5 1.5 0 000 1.5v3A1.5 1.5 0 001.5 3zM3 4.5A1.5 1.5 0 001.5 6h3A1.5 1.5 0 003 4.5zm0-3A1.5 1.5 0 004.5 0h-3A1.5 1.5 0 003 1.5zM4.5 3A1.5 1.5 0 006 4.5v-3A1.5 1.5 0 004.5 3z"
            fill="#c4f4f4"
          />
        </pattern>
        <style>
          {
            ".lightbulb_svg__cls-4{fill:#fff;stroke-linejoin:round;stroke:#28bbbb;stroke-linecap:round;stroke-width:3px}"
          }
        </style>
      </defs>
      <circle cx={84.58} cy={83.54} r={80} fill="#eefffd" />
      <path
        d="M84.58 46a37.42 37.42 0 00-26.77 63.61c3.77 3.84 6.87 7.76 8.8 13.33h35.94c1.5-5.75 5-9.49 8.8-13.33A37.43 37.43 0 0084.58 46zm18.93-4.63l6.76-14.51m13.71 17.8l13.25-11.11m-21.12 17.72l3.46-2.91m-67.01 2.91l-20.1-16.86M23.3 58.83l1.24.34m17.97 4.81l-12.08-3.24m120.21-3.32l-1.4.37m-23.1 6.19l17.76-4.76M84.58 25.73V8.48m0 29.69v-5.49M57.92 21.46l-1.67-3.59m10.96 23.5l-6.77-14.51"
        className="lightbulb_svg__cls-4"
      />
      <path
        fill="none"
        stroke="#28bbbb"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={3}
        d="M89.55 103.22c.26-3.66.95-14.72 1.06-15.9.17-1.81.89-3.82 2.9-4.62 2.6-1 6 .8 5.24 4.14-.92 4.07-4.81 4-7.82 3.71s-5.81-.74-8.69-1.21c-4.68-.76-16.44-1.65-14.74-9.11A5.62 5.62 0 0173 76c4.49.13 5.48 4.56 5.84 8.12 1 9.63 1.39 19.31 2.07 29"
      />
      <path
        fill="url(#lightbulb_svg__New_Pattern_6)"
        stroke="#28bbbb"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={3}
        d="M103.2 140H66.26a1 1 0 01-1-1v-15.07a1 1 0 011-1h36.94a1 1 0 011 1V139a1 1 0 01-1 1z"
      />
      <path
        d="M85 147.13a6.77 6.77 0 006.92-6.61H78a6.77 6.77 0 007 6.61z"
        className="lightbulb_svg__cls-4"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgLightbulb);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
